export { default, type ToastTemplateProps } from './ToastTemplate';
